module.exports = __webpack_public_path__ + "static/media/tm.c8f7210d.svg";